// extracted by mini-css-extract-plugin
export var fullWidthButton = "_zi-0";
export var tagInputDisabled = "_zi-1";